import api from "./config";

export const enableUser = (userId) => {
  return api.post(`/api/users/${userId}/enable`);
};
export const disableUser = (userId) => {
  return api.post(`/api/users/${userId}/disable`);
};
